import AccordionExpandCollapseActions from '../AccordionExpandCollapse.js';

/* Button that expands all accordion dropdowns */
var revealQuesBtn = document.querySelector('.skye-accordion__expand__all');

/* String for inner HTML for when button changes states after collapsing all dropdowns */
var buttonLabelDefault = '<span>Show all</span> <span>FAQ answers</span>';

/* String for inner HTML for when button changes states after expanding all dropdowns */
var buttonLabelExpanded = '<span>Hide all</span> <span>FAQ answers</span>';

/* Normal button for accordion */
var accordionExpandButton = document.querySelectorAll('.skye-accordion__button');

/* Collapsing elements in the accordion */
var collapsingEle = document.querySelectorAll('div[data-parent="#accordion"]');

/* Instantiate and run the expansion actions */
var accordionActions = new AccordionExpandCollapseActions( revealQuesBtn,  buttonLabelDefault, buttonLabelExpanded, accordionExpandButton, collapsingEle );
accordionActions.AccordionExpandCollapse();